export default {
  roomPreferenceEnter: {},
  roomPreferenceEnterActive: {},
  roomPreferenceLeave: {},
  roomPreferenceLeaveActive: {},
  heading: {},
  travelClubTextWidth: {},
  roomDetails: {},
  roomCharacteristic: {},
  defaultStyle: {
    background: '#fff',
    margin: '0 auto 60px',
    '& > ul': {
      listStyle: 'none',
      margin: '0',
      font: data => '300 13px ' + data.fontFamily1,
      color: '#000',
      background: '#fff',
      padding: '0 0 0 10px',
      '@media (min-width: 902px)': {
        padding: '0px',
      },
      '& > li': {
        padding: '10px 0',
        display: 'table',
        width: '100%',
        position: 'relative',
        '&:not(:last-of-type)': {
          marginBottom: '0px',
          '&:after': {
            content: "''",
            position: 'absolute',
            left: '-10px',
            bottom: '0',
            right: '0',
            borderTop: '1px solid #d8d8d8',
            '@media (max-width: 901px) ': {
              left: '0',
              border: '0',
            }
          },
          '&:lang(ar)': {
            '&:after': {
              left: '0',
              right: '-10px',
            }
          }
        },
        '@media (max-width: 901px)': {
          padding: '0',
          display: 'block',
          marginBottom: '5px',
          '&:not(:last-of-type)': {
            marginBottom: '30px'
          }
        }
      },
      '@media (max-width: 901px)': {
        display: 'block',
        padding: '0 0 10px'
      },
      '&:lang(ar)': {
        paddingLeft: '0',
        paddingRight: '10px',
        '@media (max-width: 901px) ': {
          paddingLeft: "7px",
          paddingRight: "7px"
        }
      }
    },
    '& $roomPreferenceEnter': {
      transition: 'max-height 0ms ease-out',
      maxHeight: '0'
    },

    '& $roomPreferenceEnterActive': {
      maxHeight: '300px',
      transition: 'max-height 700ms ease-out',
      overflow: 'hidden'
    },

    '& $roomPreferenceLeave': {
      maxHeight: '300px',
      transition: 'max-height 700ms ease-out',
      overflow: 'hidden'
    },

    '& $roomPreferenceLeaveActive': {
      transition: 'max-height 700ms ease-out',
      maxHeight: '0'
    },

    '@media (min-width: 801px)': {
      //margin: '0 auto 80px',
    },

    '&:lang(ar)': {
      direction: 'rtl'
    }
  },
  header: {
    '@media (min-width: 902px)': {
      position: 'relative',
      paddingBottom: '21px',
    },
    '& $positionImage': {
      '&:lang(ar)': {
        '@media (min-width: 902px)': {
          left: 'auto',
          right: 0
        }
      },
      '& > button':{
        '@media (min-width: 902px)': {
          width:'294px',
        }
      },
      '@media (min-width: 902px)': {
        display: 'block',
        position: 'absolute',
        width: '294px',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        top: '0',
        left: '0',
        bottom: '0',
        backgroundPosition: 'center',
        height: '190px',
      }
    },
    '& $heading': {
      '@media (min-width: 902px)': {
        padding: '0px 24px 20px 314px',
        minHeight:'153px'
      },
      backgroundColor: '#fff',
      padding: '10px 0',
      '& > button': {
        display: 'block',
        width: '100%'
      },
      '& $roomDetails': {
        textAlign: 'center',
        display: 'table',
        width: '100%',
        '@media (min-width: 902px)': {
          textAlign: 'left',
          paddingBottom: '17px',
          display: 'block'
        },
        '& $roomCharacteristic': {
          margin: '16px 0 16px 0px',
          display: 'block',
          width: 'auto',
          height: '1px',
          backgroundColor: '#D8D8D8',
          '@media (min-width: 902px)': {
            fontSize: '14px',
            padding: '0 14px',
            display: 'inline-block',
            width: 'auto'
          }
        },
        '& > button': {
          display: 'table-cell',
          verticalAlign: 'middle',
          width: '100%',
          padding: '0 3px',
          '& > span': {
            display: 'inline',
            fontSize: '13px',
            '& > span': {
              padding: 0,
              color: data => data.mainColor,
              display: 'inline'
            }
          },
          '@media (min-width: 801px)': {
            padding: '0 14px',
            display: 'inline-block',
            width: 'auto',
            '& > span': {
              fontSize: '14px'
            }
          }
        },
        '&:lang(ar)': {
          '@media (min-width: 902px)': {
            textAlign: 'right'
          }
        }
      },
      '& $amenitiesContainer': {
        display: 'none',
        '@media (min-width: 902px)': {
          display: 'block',
          position: 'relative',
          minHeight: '70px'
        },
        '&:lang(ar)': {
          '@media (min-width: 902px)': {
            textAlign: 'right'
          }
        }
      },
      '&:lang(ar)': {
        '@media (min-width: 902px)': {
          paddingLeft: "24px",
          paddingRight: "314px"
        }
      },
      '& .travelClubTextWidth': {
        '@media (min-width: 901px)':{
          maxWidth: '660px',
        }
      },
    }
  },
  positionImage: {
    position: 'relative',
    width: '100%',
    height: '160px',
  },
  redRibbonContainer: {
    position: 'relative',
    zIndex: '1',
  },
  redRibbon: {
    display: 'block',
    backgroundColor: '#d0021b',
    minWidth: '80px',
    height: '24px',
    fontSize: '11px',
    textAlign: 'left',
    position: 'absolute',
    left: '-8px',
    top: '10px',
    padding: '4px',
    boxSizing:'border-box',
    '&:before': {
      content: "''",
      position: 'absolute',
      left: '100%',
      top: '0',
      borderTop: '12px solid transparent',
      borderLeft: '10px solid #d0021b',
      borderBottom: '12px solid transparent',
    },
    '&:after': {
      content: "''",
      position: 'absolute',
      left: '0',
      top: '100%',
      borderTop: '8px solid #821b27',
      borderLeft: '8px solid transparent',
    },
    '@media (min-width: 902px)': {
      minWidth: '150px',
      fontSize: '16px',
      padding: '3px',
      height: '28px',
      textAlign: 'center',

      '&:before': {
        borderTopWidth: '14px',
        borderBottomWidth: '14px'
      },

      '&:after': {
        content: "''",
        position: 'absolute',
        left: '0',
        top: '100%',
        borderTop: '8px solid #821b27',
        borderLeft: '8px solid transparent'
      }
    },
    '&:lang(ar)': {
      left: 'auto',
      right: '-8px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      '&:before': {
        left: "auto",
        right: "100%",
        borderLeft: "none",
        borderRight: "10px solid #d0021b"
      },
      '&:after': {
        left: "auto",
        right: "0",
        borderLeft: "none",
        borderRight: "8px solid transparent",
        '@media (min-width: 902px)': {
          left: "auto",
          right: "0",
          borderLeft: "none",
          borderRight: "8px solid transparent"
        }
      },
      '& > span': {
        '&:last-of-type': {
          marginRight: '5px',
        }
      }
    },
  },
  amenitiesContainer: {
    position: 'relative'
  },
  noRibbon: {
    '& $header': {
      '@media (min-width: 902px)': {
      position: 'relative',
      paddingBottom: '21px',
      },
      '& $heading': {
        padding: '10px 0px',
        '&:lang(ar)': {
          paddingRight: "10px",
          paddingLeft: "10px",
          '@media (min-width: 902px) ': {
            paddingRight: "314px",
            paddingLeft: "24px"
          }
        },
        '@media (min-width: 902px) ': {
          padding: '0px 24px 20px 314px',
        }
      }
    }
  },
  paddingTravelClub:{
    paddingRight: '160px',
  },
  logoRoomContainer:{
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  travelClubContainer:{
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    marginLeft: '15px',
    '& svg': {
      height: '60px',
      width: '60px',

    },
    '&  div': {
      '&  svg': {
      height: '40px',
      width: '50px',
      }
    },
    '&:lang(ar)':{
      right: 'auto',
      left: '0',
    },
  },
  travelClubLogoWithOutPlane: {
    marginLeft: '15px',
    '& svg': {
      height: '60px',
      width: '140px',
      '@media (max-width: 801px)': {
        height: '60px',
        width: '120px',
      }
    }
  },
  travelClubTextContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    font: '14px Roboto, sans-serif',
    color: '#666',
    textAlign: 'center',
  },
  travelClubText:{
    textTransform: 'uppercase',
    fontWeight: 'bold',
    color: '#000',
    fontSize: '15px',
  },
  maxOcupation: {
    display: 'table-cell',
    verticalAlign: 'middle',
    width: '42%',
    padding: '0 3px',
    borderRight: '1px solid #d8d8d8',
    fontFamily: 'Roboto, sans-serif',
    '& > span': {
      fontSize: '13px',
      display: 'inline'
    },
    '&:last-of-type': {
      borderRight: '0',
      '&:lang(ar)': {
        borderLeft: 'none'
      }
    },
    '&:lang(ar)': {
      borderRight: "none",
      borderLeft: "1px solid #d8d8d8",
      '&:last-of-type': {
        '@media (min-width: 801px)': {
          marginLeft: 0
        }
      },
      '@media (min-width: 801px)': {
        paddingRight: "0",
        paddingLeft: "14px",
        marginRight: "0",
        marginLeft: "14px"
      }
    },
    '@media (min-width: 801px)': {
      padding: '0 14px 0 0',
      display: 'inline-block',
      width: 'auto',
      borderRight: '1px solid #D8D8D8',
      marginRight: '14px',
      '&:last-of-type': {
        marginRight: '0'
      },
      '& > span': {
        fontSize: '14px'
      }
    }
  },
  noDispoCalendarInfo:{
    padding:'10px',
    textAlign:'center',
    '@media(min-width:801px)':{
      display:'flex',
      alignItems:'center',
      justifyContent:'space-between',
      padding:'10px 20px 10px 10px'
    },
    '@media(min-width:901px)':{
      paddingLeft:'0px'
    }
  },
  noAvailInfoIcon:{
    fontSize:'18px',
    marginRight:'5px',
    position:'absolute',
    left:'0',
    top:'0'
  },
  noAvailInfoText:{
    font:data=>'400 14px/18px ' + data.fontFamily1
  },
  noAvailInfoTextBold:{
    composes : '$noAvailInfoText',
    fontWeight:'500'
  },
  noDispoCalendarCell:{
    paddingBottom:'10px',
    '&:last-of-type':{
      paddingBottom:'0',
    },
    '& > button':{
      maxWidth:'250px',
      height:'40px',
      padding:'5px 10px',
      '@media(min-width:801px)':{
        maxWidth:'none',
        boxSizing:'border-box'
      }  
    },
    '& button':{
      '& > span':{
        '& > span':{
          display:'none'
        }
      },
    },
    '@media(min-width:801px)':{
      padding:0,
    }
  },
  noDispoCalendarTextCell:{
    display:'inline-block',
    verticalAlign:'middle',
    paddingLeft:'23px',
    paddingBottom:'10px',
    position:'relative',
    textAlign:'center',
    '@media(min-width:801px)':{
      paddingBottom:'0',
    }
  },
  noDispoCalendarTextCellContent:{ 
    display:'inline-block',
    verticalAlign:'middle',
    textAlign:'left',
    '&:lang(ar)': {
      display: 'flex',
      alignItems: 'center',
      gap: '2px',
    }
  },
  noDispoCalendar:{},
  dateChangeButton: data =>({
    textAlign:'right',
    padding:'0 10px 10px',
    [`@media (min-width: ${data.modalBreak}px)`]: {
      padding:'0 35px 20px',
    }  
  }),
  loyalty: {
    textAlign: 'right',
    border: '0 !important',
    boxShadow: 'none !important',
    '& > span': {
      marginRight: '6px',
      fontSize: '0.7rem',
    }
  },
  noAvailRoomDetailModal:{
    background:'red'
  },
  datepickerContainer:{
    position:'relative',
    paddingTop:'10px'
  },
  datepickerCloseButton:{
    top: '13px',
    right: '14px',
    position: 'absolute',
    zIndex: '10',
    background: 'none',
    cursor: 'pointer',
    color: data => data.mainColor,
    border: '0',
    fontSize: '15px',
    '&:lang(ar)':{
        right: "auto",
        left: "14px",
    },
  },
  buttonStModal:{
    backgroundColor: '#f5f4f6',
    font: '14px "Roboto", sans-serif',
    border: 'none',
    color: data => data.STdefaultTier,
    borderRadius: '20px',
    cursor: 'pointer',
    fontWeight: '100',
    padding: '6px 11px',
    marginTop: '10px',
    '@media (min-width: 901px)': {
      marginTop: '0',
    },
  },
  buttonSTbreakfast: {
    '@media (max-width: 370px)': {
      fontSize: '12px'
    }
  },
  buttonStarTravel:{
    '@media (max-width: 900px)':{
      marginTop: '10px',
    },
    '& > button':{
      cursor: 'pointer',
      height: '25px',
    },
    '@media (min-width: 902px)': {
      position: 'absolute',
    }
  },
  hiddenButoom:{
    visibility: 'hidden',
  },
  dispoPickerAvail:{
    '& > div':{
      '&> div':{
        '@media(min-width:901px)':{
          paddingTop: '20px'
        }
      }
    }
  },
  visibiltyHidden:{
    width: '0',
    padding: '0',
    margin: '0',
    overflow: 'hidden',
    border: '0',
    whiteSpace: 'nowrap',
    position: 'absolute',
  },
  promoCodeIcon:{},
  promoDescripction:{
    display: 'flex',
    gap: '8px',
    marginTop: '5px',
    marginBottom: '10px',
    '& $promoCodeIcon':{
      fill: data => data.mainColor,
    },
    '@media (min-width: 901px)': {
      marginTop: 'unset',
    },
  },
  discountDescripction:{
    marginBottom: '10px',
    display: 'inline-block',
    borderRadius: '4px',
    color: data => data.mainColor,
    padding: '2px 9px',
    fontFamily: data => data.fontFamily1,
    border: data => '2px solid ' + data.mainColor,
  },
  mediaExtraIcons: {
    position: 'absolute !important',
    top: 'auto !important',
    left: '45px !important',
    right: 'auto !important',
    bottom: '10px !important',
    zIndex: 2,
    display: 'flex !important',
    alignItems: 'center',
    gap: '4px',
  },
  mediaExtraIconsNoGallery: {
    left: '5px !important',
  },
  buttonImageVideo: {
    position: 'static !important',
    width: '36px !important',
    height: '36px !important',
    boxSizing: 'border-box',
    background: 'rgba(0,17,27,.6) !important',
    borderRadius: '50%',
    border: 'none !important',
    cursor: 'pointer',
    margin: '0 !important',
    padding: '0 !important',
    '& > span': {
      position: 'static !important',
      left: 'auto !important',
      bottom: 'auto !important',
      background: 'none !important',
      width: 'auto !important',
      height: 'auto !important',
      fontSize: '22px !important',
      lineHeight: '36px !important',
      color: '#fff',
    },
  },
  buttonImage360: {
    position: 'static !important',
    width: '36px !important',
    height: '36px !important',
    boxSizing: 'border-box',
    background: 'rgba(0,17,27,.6) !important',
    borderRadius: '50%',
    border: 'none !important',
    cursor: 'pointer',
    margin: '0 !important',
    padding: '0 !important',
    '& > span': {
      position: 'static !important',
      left: 'auto !important',
      bottom: 'auto !important',
      background: 'none !important',
      width: 'auto !important',
      height: 'auto !important',
      fontSize: '22px !important',
      lineHeight: '36px !important',
      color: '#fff',
    },
  },
};
